import * as HELPERS from '@/helpers/helpers';

const defaultState = {
  currentDisplayMode: 'widget',
  currentTheme: 'light',
  currentButtonMode: 'button',
  currentIconMode: 'icon',
  currentAvatarPose: 'stay',
  currentTitle: '👋 Hi!',
  currentSubTitle: 'We help your business to connect with your customers',
  titleImageUrl: 'https://evergreens.com.ua/assets/images/products/kwiz-preview.png',
  botAvatarImageUrl: 'https://evergreens.com.ua/assets/images/products/kwiz-preview.png',
  avatarScale: {
    min: 6,
    max: 18,
    current: 11,
  },
  widgetAction: null,
  isWidgetInit: false,
  botId:1,
  paramsFromSite: {},

  launcherImgSrc: 'https://www.w3schools.com/w3images/avatar2.png',

  multi_channel: {
    button_title: 'Contact us',
    messengers: {
      'viber': '',
      'telegram': '',
      'facebook': '',
      'whatsapp': '',
      'instagram': '',
    },
  },
	timeout_mode: 0,
	timeout_value: 3000,
	preview_demo: 0,
	recognize_user_meta: false,
	widget_button_animation: false,
};

const state = {
  displayModes: [
    { id: 1, name: 'Widget', value: 'widget' },
    { id: 2, name: 'Frame', value: 'frame' },
    { id: 3, name: 'Inline', value: 'inline' },
  ],
  currentDisplayMode: 'widget',

  themes: [
    { id: 1, name: 'Light', value: 'light' },
    { id: 2, name: 'Dark', value: 'dark' },
  ],
  currentTheme: 'light',

  buttonModes: [
    { id: 1, name: 'Button', value: 'button' },
    { id: 2, name: 'Bar', value: 'bar' },
    { id: 3, name: 'Avatar', value: 'avatar' },
    { id: 4, name: 'Multi-channel', value: 'multi' },
  ],
  currentButtonMode: 'button',

  iconModes: [
    { id: 1, name: 'Icon', value: 'icon' },
    { id: 2, name: 'Image', value: 'image' },
  ],
  currentIconMode: 'icon',

  avatarPoses: [
    { id: 1, name: 'Stay', value: 'stay' },
    { id: 2, name: 'Hand', value: 'hand' },
    { id: 3, name: 'Jump', value: 'jump' },
  ],
  currentAvatarPose: 'stay',

  avatarScale: {
    min: 6,
    max: 18,
    current: 11,
  },

  widgetAction: null,
  isWidgetInit: false,
  currentTitle: '👋 Hi!',
  currentSubTitle: 'We help your business to connect with your customers',
  titleImageUrl: 'https://evergreens.com.ua/assets/images/products/kwiz-preview.png',
  botAvatarImageUrl: 'https://evergreens.com.ua/assets/images/products/kwiz-preview.png',
  botId:1,
  paramsFromSite: {},

  launcherImgSrc: 'https://www.w3schools.com/w3images/avatar2.png',

  multi_channel: {
    button_title: 'Contact us',
    messengers: {
      'viber': '',
      'telegram': '',
      'facebook': '',
      'whatsapp': '',
      'instagram': '',
    },
  },

	timeout_mode: 0,
	timeout_value: 3000,
	preview_demo: 0,
	recognize_user_meta: false,
	widget_button_animation: false,
};

const mutations = {
  SET_WIDGET_ACTION(state, actionData) {
    /**
     * actionData - { type, value }
     */
    state.widgetAction = actionData;
  },

  SET_CURRENT_PARAM(state, { path, value }) {

    const defaultValue = HELPERS.getValueAtPath({
      path,
      object: defaultState,
    });

    HELPERS.setValueAtPath({
      path,
      value,
      defaultValue,
      object: state,
    });
  },

  SET_IS_WIDGET_INIT(state, isInit) {
    state.isWidgetInit = isInit;
  },
};

const actions = {
  setWidgetAction({ commit }, actionData) {
    /**
     * actionData - { type, value }
     */

    commit('SET_WIDGET_ACTION', actionData);
  },

  setCurrentParam({ commit }, stateData) {
    /**
     * stateData - { path, value }
     */
    commit('SET_CURRENT_PARAM', stateData);
  },

  setIsWidgetInit({ commit }, isInit) {
    commit('SET_IS_WIDGET_INIT', isInit);
  },
};

const getters = {
  isDisplayMode(state) {
    return (mode) => state.currentDisplayMode === mode;
  },

  getCurrentTitle(state){
    return  state.currentTitle;
  },

  getCurrentSubTitle(state){
    return  state.currentSubTitle;
  },

  getCurrentTitleImageUrl(state){
    return  state.titleImageUrl;
  },

  getCurrentBotAvatarUrl(state){
    return  state.botAvatarImageUrl;
  },
  getBotId(state){
    return  state.botId;
  },

  isButtonMode(state) {
    return (mode) => state.currentButtonMode === mode;
  },
	previewDemo: (state) => state.preview_demo,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
